import { useFormContext } from 'react-hook-form';
import { UncontrolledCheckbox } from 'components/Form';
import { defaultDetail } from './VenueDetail';

const t = {
  van: 'Van',
  boxvan: 'Box Van',
  light_rigid: 'Light Rigid',
  heavy_rigid: 'Heavy Rigid',
  trailer: 'Trailer',
};

const t_errors = {
  required: 'Select at least one accepted vehicle',
};

const VenueVehicle = ({ value, fieldName }) => {
  const { register } = useFormContext();

  return (
    <UncontrolledCheckbox
      label={t[value]}
      value={value}
      girded
      wrapperProps={{
        style: { marginRight: 8 },
      }}
      {...register(fieldName, { required: t_errors.required })}
    />
  );
};

const VenueAcceptedVehiclesRenderer = ({
  value: acceptedVehicles,
  isEditing,
  fieldName,
  error,
}) => {
  if (isEditing) {
    return (
      <div className="field-container">
        {Object.keys(t).map((value) => (
          <VenueVehicle key={value} value={value} fieldName={fieldName} />
        ))}
        {!!error?.message && <div className="field-error">{error.message}</div>}
      </div>
    );
  }

  if (!acceptedVehicles?.length) {
    return <>{defaultDetail}</>;
  }

  return <>{acceptedVehicles.map((vehicle) => t[vehicle] || vehicle).join(', ')}</>;
};

export default VenueAcceptedVehiclesRenderer;
